// extracted by mini-css-extract-plugin
module.exports = {"ProductSetDetails":"styles_ProductSetDetails__6T_40","setItems":"styles_setItems__DjaIc"};